import React, { useRef } from "react";
import { usePFDataContext } from "../../context/PfContext";


const Search = () => {
    const { updatePfData } = usePFDataContext();
    const { pfData } = usePFDataContext();

    const searchInput = useRef(null);


    const handleSearchSubmit = (e) => {
        e.preventDefault();
        updatePfData("search", searchInput.current.value);
      };


    return (
        <div className="pf__row flex__t-column flex__t-align-center">
          <div className="product__listing--search">
            <form className="search__product" onSubmit={handleSearchSubmit}>
                <input
                    type="text"
                    placeholder="Search"
                    ref={searchInput}
                />
                <button className="search__icon" type="submit">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 512 512"
                        width="20"
                        height="20"
                    >
                        <path d="M505 442.7L405.3 343c28.3-34.8 45.7-79.3 45.7-127C451 96.5 354.5 0 231.5 0S12 96.5 12 216s96.5 216 216 216c47.7 0 92.2-17.4 127-45.7l99.7 99.7c10 10 23.2 15.4 36.3 15.4s26.3-5.2 36.3-15.4c20-20 20-52.4 0-72.5zM231.5 382c-91.3 0-166-74.7-166-166s74.7-166 166-166 166 74.7 166 166-74.7 166-166 166z" />
                    </svg>
                </button>
            </form>
          </div>
        </div>
    );
    }

export default Search;